var euruspostDeliveryOptions = {
    isSelectedEuruspostAddress: false
}
var euruspostDeliveryMethod;
var CheckoutEuruspostAddressJs = (function ($) {
    var $radioButtons;
    var $clickElem;
    var showHideEuruspostDeliveryAddress = function(target, elemSel) {
    if (target.attr("value") === euruspostDeliveryMethod) {
            $(".j-checkout-address-euruspost").show();
        }else{
             $(".j-checkout-address-euruspost").hide();
        }
     };

    var initShowHideEuruspostDel = function (radioButtonsSel, elemSel) {
        var radioBSel = radioButtonsSel + " input[type='radio']";
        showHideEuruspostDeliveryAddress($(radioBSel + '[name=deliveryMethod]:checked'), ".j-checkout-address-euruspost");
        $(radioBSel).on("click", function () {
            showHideEuruspostDeliveryAddress($(this), elemSel);
        });
    };

    return {
        initShowHideEuruspostDel: initShowHideEuruspostDel,
        showHideEuruspostDeliveryAddress: showHideEuruspostDeliveryAddress
    }
})(jQuery);

$(document).ready(function () {
    if (typeof $("#euruspostRadioButton") !== 'undefined' && typeof $("#euruspostRadioButton").val() !== 'undefined') {
        euruspostDeliveryMethod = $("#euruspostRadioButton").val();
        CheckoutEuruspostAddressJs.initShowHideEuruspostDel(".j-delivery-method-radio-buttons", ".j-checkout-address-euruspost");
    }
});